import { AxiosResponse } from 'axios';

const validateTokenResponse = (response: AxiosResponse): boolean => {
  const invalidityAlertElement = '<form method="post" id="reset-form"';
  if (!response.data.includes(invalidityAlertElement)) return false;
  return true;
};

const validateRecoveryResponse = (response: AxiosResponse): boolean => {
  const resetPasswordElement = '<ul class="errorlist"><li>';
  if (response.data.includes(resetPasswordElement)) return false;
  return true;
};

const validateNewPasswordResponse = (response: AxiosResponse): boolean => {
  const newPasswordElement = '<ul class="errorlist"><li>';
  if (response.data.includes(newPasswordElement)) return false;
  return true;
};

const resetService = { validateRecoveryResponse, validateTokenResponse, validateNewPasswordResponse };

export default resetService;